export default __webpack_public_path__ + "static/media/kj3.5f6df2bb.png";